import { observable, makeObservable, runInAction } from 'mobx';
import URL from '../httpService/API';
import { noTokenAjax as noTokenFetch } from 'grt-tool-lib-front';
import { staticUrl } from '../httpService/API';
//物料库通用url---每个物料库 都依赖这些资源
const usualUrl = [
    `${staticUrl}/v1/mylib/moment/2.24.0/min/moment.min.js`,
    `${staticUrl}/v1/platform/c/lodash/4.6.1/lodash.min.js`,
    `${staticUrl}/v1/t/font_2369445_ukrtsovd92r.js`,
    `${staticUrl}/v1/code/npm/@ali/ant-design-icons-cdn/4.5.0/index.umd.min.js`,
    `${staticUrl}/v1/code/lib/antd/4.23.0/antd.min.js`,
    `${staticUrl}/v1/code/lib/antd/4.23.0/antd.min.css`
];

function getCurScripts() {
    let scripts = document.getElementsByTagName('script'),
        len = scripts.length,
        res = [];

    for (let i = 0; i < len; i++) {
        res.push(scripts[i].src);
    }
    return res;
}
function getCurLinks() {
    let links = document.getElementsByTagName('link'),
        len = links.length,
        res = [];

    for (let i = 0; i < len; i++) {
        res.push(links[i].href);
    }
    return res;
}
//获取package属性
function getPackageProp(packageName, allPackages, prop) {
    let res = allPackages.find((ele) => {
        return ele.package === packageName;
    });

    return (res && res[prop]) || null;
}

//获取所有用到的urls
function getAllUrls(usingmaterials, packages) {
    //使用中的物料库的Url 和它的依赖的url
    let allDepsUrls = [],
        allMaterialsUrls = [];

    usingmaterials.forEach((item) => {
        if (item) {
            let depsUrl = getPackageProp(item, packages, 'depsUrl'),
                materialUrl = getPackageProp(item, packages, 'urls');

            if (depsUrl) {
                allDepsUrls = allDepsUrls.concat(depsUrl);
            }
            if (materialUrl) {
                allMaterialsUrls = allMaterialsUrls.concat(materialUrl);
            }
        }
    });
    return Array.from(new Set([...allDepsUrls]));
}

function init(packages, componentsMap) {
    let promiseArr = [],
        //当前低代码schema 中使用的物料库
        usingmaterials = Array.from(
            new Set(
                componentsMap.map((ele) => {
                    return ele.package;
                })
            )
        ),
        allUrls = getAllUrls(usingmaterials, packages),
        regJS = /.js$/,
        regCss = /.css$/,
        scriptFrag = document.createDocumentFragment(),
        linkFrag = document.createDocumentFragment(),
        curScripts = getCurScripts(), //当前scripts标签的src集合，避免重复添加
        curLinks = getCurLinks(), //当前link标签的集合，避免重复添加
        schemaUrls = usualUrl.concat(allUrls);

    curLinks = Array.from(new Set(curLinks));
    schemaUrls = Array.from(new Set(schemaUrls));
    curScripts = Array.from(new Set(curScripts)); //渲染器会像script标签添加
    schemaUrls.forEach((item) => {
        if (!window.__POWERED_BY_QIANKUN__ && regCss.test(item) && !curLinks.includes(item)) {
            let linkDom = document.createElement('link');

            linkDom.href = item;
            linkDom.rel = 'stylesheet';
            linkFrag.appendChild(linkDom);
        }
        if (regJS.test(item) && !curScripts.includes(item)) {
            let dom = document.createElement('script');

            dom.src = item;
            dom.async = false;
            dom.crossOrigin = 'anonymous';
            scriptFrag.appendChild(dom);
            let p = new Promise((resolve) => {
                dom.onload = () => {
                    resolve();
                };
            });

            promiseArr.push(p);
        }
    });
    document.head.appendChild(linkFrag);
    document.head.appendChild(scriptFrag);
    return promiseArr;
}
class LowcodeStore {
    constructor() {
        makeObservable(this);
    }

    @observable pageSchema = {};
    @observable packages = [];

    getSchema = async () => {
        let res = {
            data: {
                components_object: {
                    componentsMap: [],
                    componentsTree: [
                        {
                            componentName: 'Page',
                            id: 'root',
                            props: {},
                            fileName: 'sample',
                            hidden: false,
                            title: '',
                            isLocked: false,
                            condition: true,
                            conditionGroup: '',
                            dataSource: {
                                list: []
                            },
                            state: {
                                hello: {
                                    type: 'JSExpression',
                                    value: '"Hello AliLowCode"'
                                }
                            },
                            methods: {
                                testFunc: {
                                    type: 'JSFunction',
                                    value: 'function testFunc() {\n  console.log(\'test aliLowcode func\');\n  return /*#__PURE__*/React.createElement("div", {\n    className: "test-aliLowcode-func"\n  }, this.state.test);\n}'
                                }
                            },
                            lifeCycles: {},
                            originCode:
                                'class LowcodeComponent extends Component {\n  \n  // 你可以在这里添加自己的state，如示例中的test\n  state = {\n    hello: "Hello AliLowCode",\n  }\n  \n  \n  \n  // 你可以在这里编写函数，并且与组件的事件进行绑定，支持JSX语法\n  testFunc() {\n    console.log(\'test aliLowcode func\');\n    return (\n      <div className="test-aliLowcode-func">\n        {this.state.test}\n      </div>\n    );\n  }\n  \n}',
                            css: ''
                        }
                    ],
                    version: '1.0.0',
                    i18n: {}
                },
                config: {
                    schemaScene: 'multiple'
                }
            }
        };

        let schemaObj = res.data || {};

        let pageSchema = schemaObj['components_object'] || {};

        if (this.packages.length === 0) {
            let { packages = [] } = await noTokenFetch.get(URL.assetJson),
                a = init(packages, pageSchema.componentsMap || []);

            await Promise.all(a);
            runInAction(() => {
                this.pageSchema = pageSchema;
                this.packages = packages;
            });
        } else {
            let a = init(this.packages, pageSchema.componentsMap);

            await Promise.all(a);
            runInAction(() => {
                this.pageSchema = pageSchema;
            });
        }
        return res;
    };
}
export default new LowcodeStore();
